// extracted by mini-css-extract-plugin
export default {"input":"search-input_input__Kqt3h","icon":"search-input_icon__qd4rG"};